// 引入crypto-js包
import CryptoJS from 'crypto-js';

const config = {
  AES_KEY: '278e9b5c79b84fb49a6a614e04f1a88940a8ea01d87c47f1b0d227a861df9a3a',
  AES_IV: 'c1a954c4cb9e439db35a5170a12867dd',
};

/**
 * AES加密
 * @param {any} word 加密数据
 */
export const cryptoEncrypt = (word) => {
  const key = CryptoJS.enc.Hex.parse(config.AES_KEY);
  const iv = CryptoJS.enc.Hex.parse(config.AES_IV);
  let encrypted = '';
  let srcs = '';
  if (typeof word == 'string') {
    srcs = word;
    // srcs = CryptoJS.enc.Hex.parse(word);
  } else if (typeof word == 'object') {
    //对象格式的转成json字符串
    srcs = CryptoJS.enc.Hex.parse(word);
  }
  encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  //   return encrypted.ciphertext.toString();
  return encrypted.toString();
};

/**
 * AES解密
 * @param {any} word 解密数据
 */
export const cryptoDecrypt = (word) => {
  const key = CryptoJS.enc.Hex.parse(config.AES_KEY);
  const iv = CryptoJS.enc.Hex.parse(config.AES_IV);
  //   const encryptedHexStr = CryptoJS.enc.Hex.parse(word);
  //   const srcs = CryptoJS.enc.Hex.stringify(encryptedHexStr);
  const decrypt = CryptoJS.AES.decrypt(word, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  const decryptedStr = decrypt.toString(CryptoJS.enc.Hex);
  return decryptedStr.toString();
  //   return decrypt.toString();
};
